import { Icon, IconsEnum } from 'components/Icons';
import { ItemWithTranslation, SportsToolTipInfoScommessa } from 'types/swagger';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect, useState } from 'react';

import classNames from 'classnames';
import { handleInfoScommesseModal } from 'features/modal/modalSlice';
import { selectIsScommessaLoading } from 'features/sport';
import { setAccordionFilter } from 'features/sport/sportSlice';
import styles from './ScommesseAccordionFilterSecondary.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type ScommesseAccordionFilterSecondaryProps = ItemWithTranslation<{ label: string; selectedFilter: string }> & {
  children: React.ReactNode;
  hasMarginBottom?: boolean;
  isAccordionClosed?: boolean;
  hasMarginRight?: boolean;
  className?: string;
  scommesseDescription?: Array<SportsToolTipInfoScommessa>;
};

export const ScommesseAccordionFilterSecondary = ({
  label,
  children,
  labelTrKey,
  hasMarginBottom,
  selectedFilter,
  isAccordionClosed,
  selectedFilterTrKey,
  hasMarginRight,
  className,
  scommesseDescription,
}: ScommesseAccordionFilterSecondaryProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  // should be on buttons, but here is most centralized
  const isScommessaLoading = useTypedSelector(selectIsScommessaLoading);

  useEffect(() => {
    if (isAccordionClosed) {
      setIsOpen(false);
      dispatch(setAccordionFilter(false));
    }
  }, [isAccordionClosed, dispatch]);

  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.marginBottom]: hasMarginBottom,
          [styles.marginRight]: hasMarginRight,
        },
        className ? className : ''
      )}
    >
      <div className={styles.button} onClick={() => setIsOpen(!isOpen)} role="button">
        <div className={scommesseDescription ? styles.titleWithInfoScommesse : ''}>
          <p className={styles.text}>
            {t(labelTrKey, label)}&nbsp;-&nbsp;{selectedFilter && <span>{t(selectedFilterTrKey, selectedFilter)}</span>}
          </p>
          {scommesseDescription && (
            <button
              type="button"
              className={styles.buttonInfoScommessa}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  handleInfoScommesseModal({ isOpen: true, title: selectedFilter, description: scommesseDescription })
                );
              }}
            >
              <Icon iconId={IconsEnum.INFO} className={styles.iconInfoScommessa} color="var(--color-on-bg-secondary)" />
            </button>
          )}
        </div>
        <Icon
          iconId={IconsEnum.CHEVRON_DOWN}
          className={classNames(styles.icon, { [styles.rotate]: isOpen })}
          color="var(--color-on-bg-primary)"
        />
      </div>
      <div
        className={classNames(
          styles.main,
          { [styles.disabled]: isScommessaLoading },
          isOpen ? styles.visible : styles.hidden
        )}
      >
        <div className={styles.childrenWrapper}>{children}</div>
      </div>
    </div>
  );
};
